import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-archivo-agregado',
  templateUrl: './archivo-agregado.component.html',
  styleUrls: ['./archivo-agregado.component.scss']
})

export class ArchivoAgregadoComponent {
  @Input() archivo!: File;
  @Output() eliminar: EventEmitter<string> = new EventEmitter<string>();

  get nombre(): string {
    if (!this.archivo?.name) return '';
    const partes = this.archivo.name.split('.');
    partes.pop(); // saco la extensión
    return partes.join('.');
  }

  get extension(): string {
    if (!this.archivo?.name) return '';
    const partes = this.archivo.name.split('.');
    return partes.length > 1 ? '.' + partes.pop() : '';
  }

  get size(): string {
    if (!this.archivo) return '';
    const kb = this.archivo.size / 1024;
    return kb > 1024
      ? (kb / 1024).toFixed(2) + ' MB'
      : kb.toFixed(0) + ' KB';
  }

  eliminarArchivo() {
    this.eliminar.emit(this.archivo.name);
  }

}
